export default {"src":"/catalog/_next/static/media/favicon.62806f8a.ico","height":256,"width":256,"blurWidth":0,"blurHeight":0};